import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, useNavigate } from 'react-router-dom'

import { filterActiveProducts } from '@actions/checkout'
import { getProductsGroup } from '@services/sm-api'
import TransferList from '@components/TransferList'
import { TransferListProvider } from '../../../hooks/useTransferList'
import CreditCard from '@components/CreditCard'

import V2Layout from '../V2Layout'
import V2Stepper from '../V2Stepper'
import V2CartAside from '../V2CartAside'

// Pagamento com dois cartões no V2 — a tela mais densa do fluxo.
// DECISÃO DE ARQUITETURA (mesma da Atualização): a segmentação (TransferList,
// TC-05..TC-08) e os dois formulários (CreditCard em modo products, TC-09..TC-13
// + CC-*) são os componentes V1 reusados POR INTEIRO; este wrapper só orquestra
// os painéis (como o Payment V1 faz via Swap) dentro do chrome V2, com skin CSS.
// TC-02 (regras + aceite) fica no Resumo, que só navega para cá após o aceite
// (guarda smd_v2_twocards, consumida no mount — refresh volta ao Resumo, como o
// Swap do V1 volta ao painel inicial). TC-04: products_group consultado aqui.
// A conclusão usa a ponte já existente no CreditCard (smd_v2_flow → /v2/steps/concluido).

export default function V2TwoCards() {
  const navigate = useNavigate()
  const checkout = useSelector(state => filterActiveProducts(state))
  const order = useSelector(state => state.creditCard || {})

  // pedido concluído nesta visita? (o CreditCard limpa o checkout ANTES de navegar —
  // sem esta guarda, o redirect de "carrinho vazio" competiria com a navegação dele)
  const orderIdOnMount = useRef(order.order_id || null)
  const orderCompleted = !!order.order_id && order.order_id !== orderIdOnMount.current

  const [allowed] = useState(() => {
    const ok = sessionStorage.getItem('smd_v2_twocards') === '1'
    sessionStorage.removeItem('smd_v2_twocards')
    return ok
  })
  const [phase, setPhase] = useState('transfer')
  const [groups, setGroups] = useState(null)
  const [distributed, setDistributed] = useState(null)

  useEffect(() => {
    sessionStorage.setItem('smd_v2_flow', '1')
    if (!allowed || !checkout.length) return
    // TC-04: agrupamento dos produtos do 1º voucher para a segmentação
    getProductsGroup(checkout[0].products).then(products => setGroups(products))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (!allowed || (!checkout.length && !orderCompleted)) {
    return <Navigate to="/v2/steps/resumo" replace />
  }

  return (
    <V2Layout>
      <V2Stepper current={3} />
      <div className="v2-step-grid v2-twocards" style={{ maxWidth: '1200px', margin: '0 auto', padding: '48px 32px 110px', display: 'grid', gridTemplateColumns: '1fr 340px', gap: '40px', alignItems: 'start' }}>
        <div className="v2-uuf">
          <h1 style={{ margin: 0, fontFamily: 'Poppins,sans-serif', fontWeight: '600', fontSize: '34px', lineHeight: '1.15', letterSpacing: '-0.7px', color: '#373535' }}>
            Pagamento com dois cartões
          </h1>
          <p style={{ margin: '12px 0 0', maxWidth: '620px', fontSize: '16px', lineHeight: '1.6', color: '#6B6664' }}>
            {phase === 'transfer'
              ? 'Defina o conjunto de livros do kit a ser pago em cada cartão e continue para os dados dos cartões.'
              : 'Preencha os dados dos dois cartões. A compra só é confirmada com a aprovação de ambos.'}
          </p>

          {phase === 'transfer' && (
            <div id="v2-twocards-transfer" style={{ marginTop: '10px' }}>
              {groups ? (
                <TransferListProvider>
                  <TransferList
                    groupProducts={groups}
                    setProductsToCreditCard={d => {
                      // TC-07: [cartão 1, cartão 2] definidos → formulários
                      setDistributed(d)
                      setPhase('forms')
                      window.scrollTo(0, 0)
                    }}
                  />
                </TransferListProvider>
              ) : (
                <p style={{ marginTop: '24px', fontSize: '14px', color: '#6B6664' }}>Carregando a segmentação…</p>
              )}
            </div>
          )}

          {phase === 'forms' && (
            <div id="v2-twocards-forms" style={{ marginTop: '10px' }}>
              <button
                type="button"
                onClick={() => setPhase('transfer')}
                style={{ border: 'none', background: 'none', padding: 0, margin: '14px 0 0', fontSize: '13px', fontWeight: '700', color: '#6B6664', cursor: 'pointer' }}
              >
                ← Refazer a divisão dos cartões
              </button>
              <CreditCard products={distributed} />
            </div>
          )}
        </div>

        <V2CartAside
          cta={
            <button
              type="button"
              onClick={() => navigate('/v2/steps/resumo')}
              style={{ border: 'none', background: 'none', padding: '4px', fontSize: '13px', fontWeight: '700', color: '#6B6664', cursor: 'pointer' }}
            >
              ← Voltar ao resumo
            </button>
          }
        />
      </div>
    </V2Layout>
  )
}
